import React, { Component } from 'react';
import { connect } from 'react-redux';
import { fetchFranchiseListings } from '../../state/actions/franchise';
import BusinessFranchiseListingItem from '../../common/components/BusinessFranchiseListingItem';
import BusinessFranchisePlaceholder from '../../common/components/BusinessFranchisePlaceholder';
import FadeIn from 'react-fade-in';
import Pagination from '../../common/components/Pagination';
import randomstring from 'randomstring';
import { setHeaders, resetHeaders } from './../../state/actions/layout';

class FranchiseListings extends Component {
  constructor(props) {
    super(props);
    this.state = { loading: true };
  }

  componentDidMount() {
    this.props.fetchFranchiseListings();

    this.props.setHeaders({
      title: 'Frachise - Franchise opportunities | CompexAfrica',
      description:
        'Buy a Franchise in Nigeria, Africa and overseas. Franchise your Business. Verified Franchises for sale. Verified Contact Details. Connect with Franchise',
      url: this.props.history.location.pathname,
      keywords:
        'Franchise Opportunities, Buy a Franchise, Sell your Franchise, Franchise Buyers',
    });
  }

  componentDidUpdate(prevProps) {
    if (this.props.franchiseListings !== prevProps.franchiseListings) {
      this.setState({ ...this.state, loading: false });
    }
  }

  componentWillUnmount() {
    this.props.resetHeaders();
  }

  onPageChange = page => {
    if (typeof page === 'number') {
      this.setState({ loading: true });
      this.props.fetchFranchiseListings(page);
    }
  };

  onPreviousPage = () => {
    this.setState({ loading: true });
    this.props.fetchFranchiseListings(this.props.pageNumber - 1);
  };

  onNextPage = () => {
    this.setState({ loading: true });
    this.props.fetchFranchiseListings(this.props.pageNumber + 1);
  };

  render() {
    const { franchiseListings, pageNumber, pageSize, totalCount } = this.props;

    let placeholders = [];
    for (let i = 0; i < 9; i++) {
      placeholders.push(
        <FadeIn key={randomstring.generate()}>
          <div
            style={{
              marginLeft: '19px',
              marginRight: '19px',
            }}
          >
            <BusinessFranchisePlaceholder />
          </div>
        </FadeIn>,
      );
    }

    return (
      <div className="container max-w-rem-sm-42 max-w-rem-lg-60 max-w-rem-xxl-80 max-w-rem-5xl-100">
        <div className="d-flex flex-wrap justify-content-between mb-5">
          <p className="h3 font-weight-bold">Franchise opportunities</p>
          <div className="input-group mb-3 w-30 d-none">
            <div className="input-group-prepend">
              <button className="btn btn-outline-secondary" type="button">
                Sort by
              </button>
            </div>
            <select className="custom-select" id="inputGroupSelect03">
              <option value="Choose">Choose...</option>
              <option value="mostViewed">Most viewed</option>
            </select>
          </div>
        </div>
        <div className="d-flex flex-wrap justify-content-center justify-content-sm-start">
          {this.state.loading
            ? placeholders
            : franchiseListings.map((listing, index) => (
                <FadeIn key={randomstring.generate()}>
                  <div
                    style={{
                      marginLeft: '19px',
                      marginRight: '19px',
                    }}
                  >
                    <BusinessFranchiseListingItem
                      listing={listing}
                      currentUser={this.props.currentUser}
                      whichListingType="franchise"
                    />
                  </div>
                </FadeIn>
              ))}
        </div>
        {franchiseListings.length > 0 && (
          <div className="d-flex justify-content-center">
            <Pagination
              currentPage={pageNumber}
              pageSize={pageSize}
              totalItem={totalCount}
              onPageChange={this.onPageChange}
              onPreviousPage={this.onPreviousPage}
              onNextPage={this.onNextPage}
            />
          </div>
        )}
        {!this.state.loading && franchiseListings.length === 0 && (
          <FadeIn>
            <div className="text-center py-5">
              <p className="text-danger">No Result Found</p>
            </div>
          </FadeIn>
        )}
      </div>
    );
  }
}

export default connect(
  state => ({
    franchiseListings: state.franchise.franchiseListings,
    pageNumber: state.franchise.pageNumber,
    pageSize: state.franchise.pageSize,
    totalCount: state.franchise.totalCount,
    currentUser: state.user.currentUser,
  }),
  { fetchFranchiseListings, setHeaders, resetHeaders },
)(FranchiseListings);
